/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* A reference to a snapshot with minimal information
*/
export class SnapshotReference {
  /**
  * The unique identifier of the snapshot
  */
  'id': string;
  /**
  * The point in time when the snapshot was taken
  */
  'pointInTime': Date;
  /**
  * The unique identifier of the vault where the snapshot is stored (empty for native snapshots)
  */
  'vaultId'?: string | null;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "id",
      "baseName": "id",
      "type": "string",
      "format": "uuid"
    },
    {
      "name": "pointInTime",
      "baseName": "pointInTime",
      "type": "Date",
      "format": "date-time"
    },
    {
      "name": "vaultId",
      "baseName": "vaultId",
      "type": "string",
      "format": "uuid"
    }  ];

  static getAttributeTypeMap() {
    return SnapshotReference.attributeTypeMap;
  }

  public constructor() {
  }
}

